import { useEffect } from 'react';
import * as React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Fade, IconButton, Modal } from '@mui/material';

import type { TranscriptionResponseDTO } from '@klangio/ai2notes-ts-client';
import { makeStyles } from 'tss-react/mui';
import type { WithUser } from '../../context';
import { withUserContext } from '../../context';
import {
  getViewDuration, TrackingAction, TrackingCategory, trackingService,
} from '../../services';
import { type ITheme } from '../../theme';
import { Pricing } from '../organisms/Pricing';

export interface PricingTableModalProps extends WithUser {
  open: boolean;
  transcription?: TranscriptionResponseDTO;
  handleClose: () => void;
}

const useStyles = makeStyles()((theme: ITheme) => ({
  modal: {
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    margin: '3em auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },
    '@media screen and (min-height: 820px) and (min-width: 620px)': {
      height: 'fit-content',
      margin: 'auto auto',
    },
  },
  closeIcon: {
    color: '#fff',
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 100,
  },
  background: {
    background: theme.palette.background.paper,
    color: '#fff',
    borderRadius: 5,
    overflowY: 'scroll',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
}));

const PricingTableModal: React.FC<PricingTableModalProps> = ({
  open,
  transcription,
  handleClose,
}) => {
  // const matchesSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const { classes } = useStyles();

  const onClose = () => {
    trackingService.valueObjectEvent<{
      duration?: number;
    }>(TrackingCategory.Checkout, TrackingAction.ACTION_CLOSE_CHECKOUT, {
      duration: getViewDuration((window as any).pricingTableStartTime),
    });
    console.log(
      TrackingAction.ACTION_CLOSE_CHECKOUT,
      getViewDuration((window as any).pricingTableStartTime),
    );
    handleClose();
  };

  useEffect(() => {
    (window as any).pricingTableStartTime = new Date().getTime();
  }, []);

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={onClose}
      disableEnforceFocus
      aria-labelledby="subscription-table"
    >
      <Fade in={open} timeout={300}>
        <div className={classes.background}>
          <IconButton
            className={classes.closeIcon}
            id="btn_pricing_table_close"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Pricing transcriptionId={transcription?.id} />
        </div>
      </Fade>
    </Modal>
  );
};

export default withUserContext(PricingTableModal);
